/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable no-negated-condition */
/* eslint-disable max-statements */
import assert from 'assert';
import {useEffect, useState, useRef} from 'react';
import {useIntl, FormattedMessage} from 'react-intl';

import * as store from '@/store';
import sdk from '@/sdk';
import ConfirmDialog from '@/components/ConfirmDialog';
import Checkbox from '@/components/Checkbox';
import toast, {ToastType} from '@/components/Toast';
import {Modal} from '@baidu/luffy-comp-modal';
import {Loading} from '@baidu/luffy-comp-loading';
import CopyProgress from './CopyProgress';
import styles from './index.module.scss';
import {SidebarSearchList} from '../components/LeftList/listNew';
import classNames from 'classnames';
import {MoveSearchSvg, ClearSearchInput, ExternalWarnSvg, ExternalCopyWarnSvg, DialogCloseSvg, NoteTipSvg} from '@/icons';
import Icon, {IconSize} from '@/components/Icon';
import Text, {TextType, TextColor} from '@/components/Text';
import {DialogBody, DialogFoot} from '@/components/Dialog';
import {DOC_TYPE} from '@/constants/document/doc';
import Button, {ButtonSize} from '@/components/Button';
import routers, {buildPath} from '@/config/routers';
import {MoveCopySearchNoData, NoData, StatusError} from '../components/Status';
import Input from '@/components/Input';
import {useHistory} from 'react-router-dom';
import {isMember, docEditAble} from '@/store/util';
import {feLogger, copyToBtn, docCopyToRep, clickPageMoveRep, showBatchDialog, clickBatchNoPower, clickBatchCopy} from '@/buried';
import Loadable from 'react-loadable';
import {getIsMoveRepo} from '../components/MoveOrCopyUtils';
import {isNumber} from 'lodash-es';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import BatchOperate from '../components/BatchOperate';
import {InvalidType, PageScope} from '@/Constant';
import ExternalWarnDialog from '../components/ExternalWarnDialog';

const LazyDocTree = Loadable({
    loader() {
        return import('../components/DocTree');
    },
    loading() {
        return <div></div>;
    },
});

interface CopyDocumentProps {
    copyDocument?: {type: number, docGuid: string, title: string, isSidebar: boolean, hasChild?: boolean, isBatch?: boolean, timestamp?: number};
}
let timer: any = null;
enum CopyErrorType {
    NoPermission = 403, // 403，通用
    NoPower = 301,
    NotRepoMember = 10108,
    Copying = 20121,
    OverMaxCount = 20122,
    NoRep = 16000,
    NoRepCode = 10303,
    NoPath = 16001,
    NoDoc = 16002,
    BookToBook = 16003,
    SameDoc = 16004,
    NoCurDocPermission = 16005,
    NoChildDocPermission = 16006,
    NoSelectCurDir = 16007,
    SameDocCode = 10401,
    SamePath = 16008,
    NoParent = 400,
    NoDepartment = 10305,
    ExternalTypeError = 20144,
    ExternalPublicError = 20145,
}
enum listStatus {
    loading,
    noResult,
    isError,
    list,
    noList
}
const LangTexts: any = {
    zh: {
        403: '暂无权限保存到此路径',
        404: '当前知识库不存在或已被删除',
        16000: '当前知识库不存在或已被删除',
        16001: '选择的文档路径被删除或移动',
        16002: '文档不存在或已被删除',
        16003: '无当前知识本编辑权限',
        16004: '文档不能保存到自身及其子节点下',
        16005: '暂无当前文档权限',
        10401: '文档不能保存到自身及其子节点下',
        title: '选择知识库保存路径',
        noPermission: '暂无权限更换当前文档路径',
        notFound: '文档已被删除',
        unknownError: '未知错误，请关闭后重试',
        loading: '加载中...',
        error: '加载失败，点击',
        retry: '重试',
        noData: '未找到相关结果',
        treeNoData: '知识库暂无文档，可保存至根目录',
        treeNoPower: '您没有此知识库权限，无法复制',
        treeError: '子目录加载失败，请重试',
        repositoryNotFound: '此知识库不存在或已被删除',
        noBookPermission: '无当前知识本编辑权限',
        searchPlaceholder: '搜索知识库',
        tipText: '仅展示有编辑权限知识库',
        recentTitle: '最近访问',
        cancel: '取消',
        saveTo: '保存到',
        below: '下',
        noSelected: '请先选择知识库',
        samePath: '文档不能保存到自身及其子节点下',
        saveButton: '保存到该路径下',
        saveSuccess: '保存成功',
        saveFailed: '服务异常，请稍后再试',
    },
    en: {
        403: 'No permission to save to this path',
        404: 'The current repository does not exist or has been deleted',
        16000: 'The current repository does not exist or has been deleted',
        16001: 'The selected document has been deleted or moved',
        16002: 'The document does not exist or has been deleted',
        16003: 'No edit permission for knowledge book you selected',
        16004: 'The document cannot be saved to itself or its child nodes',
        16005: 'No permission for the current document',
        10401: 'The document cannot be saved to itself or its child nodes',
        title: 'Select save path',
        noPermission: 'No permission to change the current document path',
        notFound: 'Document has been deleted',
        unknownError: 'Unknown error, please close the window and try again',
        loading: 'Loading...',
        error: '',
        retry: 'Retry',
        noData: 'No results',
        treeNoData: 'No document in repository, will save to the root directory',
        treeNoPower: 'No edit in repository, no copy',
        treeError: 'The subdirectory failed to load. Please try again',
        repositoryNotFound: 'This repository does not exist or has been deleted',
        noBookPermission: 'No edit permission for knowledge book you selected',
        searchPlaceholder: 'Search the repository',
        tipText: 'Only show repositories with editing permissions',
        recentTitle: 'Recently visited',
        cancel: 'Cancel',
        saveTo: 'Save to',
        below: '',
        noSelected: 'Please select the repository first',
        samePath: 'The document cannot be saved to itself or its child nodes',
        saveButton: 'Save to this path',
        saveSuccess: 'Saving succeeded',
        saveFailed: 'Service exception, please try again later',
    },
};

function CopyDocument(props: CopyDocumentProps) {
    const [loading, setLoading] = useState(false);
    const [showProgress, setShowProgress] = useState(false);
    const hasToastSuccess = useRef(false);
    // 滚动加载所需状态
    const [hasMore, setHasMore] = useState(true);
    const [error, setError] = useState(false);
    const [rollLoading, setrollLoading] = useState(false);
    const [curParent, setCurParent] = useState<any>(null);
    // const [repoListStatus, setRepoListStatus] = useState<listStatus>(listStatus.list);
    const [showInput, setShowInput] = useState(false);
    const [searchVal, setSearchVal] = useState('');
    const [repository, setRepository] = useState<any>([]);
    const [recentPathList, setRecentPathList] = useState<any>([]);
    const [newRepository, setNewRepository] = useState<
        {
            spaceGuid: string;
            groupGuid: string;
            repositoryGuid: string;
            operationType?: number;
            roleName?: string;
            external?: boolean;
        } | null
    >(null);
    const [isDisabled, setIsDisabled] = useState(true);
    const [open, setOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [moveIsChecked, setMoveIsChecked] = useState<boolean>(true);
    const [curDocument, setCurDocument] = useState<WizDocument>();
    const [againOpen, setAgainOpen] = useState(false);
    const [btnLoading, setbtnLoading] = useState(false);
    const [langTexts, setLangTexts] = useState({...LangTexts.zh});
    const [noRepData, setnoRepData] = useState(false);
    const [isDocChlid, setisDocChlid] = useState(false);
    const [isSidebar, setIsSidebar] = useState(true);
    const history = useHistory();
    const [showConfirm, setShowConfirm] = useState(false);
    const [isWithChild, setIsWithChild] = useState(false);
    const [isSearch, setisSearch] = useState(false);
    const [repNoExist, setRepNoExist] = useState(false);
    const [noDepartment, setNoDepartment] = useState(false);
    const [isBorder, setisBorder] = useState(true);
    const [isPageOne, setisPageOne] = useState(true);
    const [invalidVisible, setInvalidVisible] = useState(false);
    const [invalidType, setInvalidType] = useState<InvalidType>(InvalidType.noDocOrBook);

    const intl = useIntl();
    const {
        copyDocument,
    } = props;

    // 复制的文档id
    const docGuid = copyDocument ? copyDocument.docGuid : '';
    // 是否是批量复制
    const isBatch = copyDocument ? copyDocument.isBatch : false;

    async function getCurDocument(docGuid: string) {
        // 埋点
        feLogger(copyToBtn);
        const isRepMember = isMember();
        setMoveIsChecked(true);
        if (!isRepMember) {
            setMoveIsChecked(false);
        }
        try {
            const ksServer = await sdk.getKsServer();
            const result = await ksServer.getDocumentInfo(docGuid);
            setCurDocument(result);
            if (result?.childCount !== 0) {
                setisDocChlid(true);
            }
        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
        if (docGuid && !isBatch) {
            setOpen(true);
            getCurDocument(docGuid);
        }
    }, [docGuid, copyDocument, isBatch]);

    const [batchCopyList, setBatchCopyList] = useState<any[]>([]);

    function getToastText(code: string, type: ToastType) {
        toast({
            content: code,
            type: type,
            duration: 2000,
        });
    }
    useEffect(() => {
        async function getBatchCopyMoveTo() {
            try {
                const {selectedCount, filterCheckedKeys, halfCheckedKeys} = store.getTreeSelectedObj();
                const repository = store.getCurRepository();
                const ksServer = await sdk.getKsServer();
                const result = await ksServer.getBatchCopyMoveTo({
                    repositoryGuid: repository?.repositoryGuid || '',
                    parentDocGuids: filterCheckedKeys,
                    singleDocGuids: halfCheckedKeys,
                    action: 'copy',
                });
                if (!result) {
                    getToastText('检测到你的权限已经发生变化，请刷新后重试', ToastType.Error);
                    return;
                }
                if (result && result.length !== 0) {
                    const noPower = result.every((item: any) => item.perm === 'N');
                    if (noPower) {
                        getToastText('所选文档均无复制权限', ToastType.Error);
                        feLogger(clickBatchNoPower());
                        return;
                    }
                    if (selectedCount !== result.length) {
                        getToastText('所选文档已经发生变化，请刷新后重试', ToastType.Error);
                        return;
                    }
                    setBatchCopyList(result);
                    setOpen(true);
                    feLogger(showBatchDialog());
                }
            } catch (error: any) {
                console.log(error);
                if (error?.code === 301 || error?.code === 403) {
                    getToastText('检测到你的权限已经发生变化，请刷新后重试', ToastType.Error);
                } else if (isNumber(error?.code) && [10501, 10502, 10503].includes(error?.code)) {
                    getToastText('所选文档已经发生变化，请刷新后重试', ToastType.Error);
                } else if (!navigator.onLine) {
                    getToastText('网络异常，请稍后重试', ToastType.Error);
                }
            }
        }
        if (isBatch) {
            getBatchCopyMoveTo();
        }
    }, [docGuid, intl, isBatch, repository.repositoryGuid, copyDocument?.timestamp]);

    function jumpToNewRep(copyAfterDocGuid: string | undefined) {
        assert(newRepository);
        const {spaceGuid, groupGuid, repositoryGuid} = newRepository;
        const params = {
            spaceGuid: spaceGuid || '',
            groupGuid: groupGuid || '',
            repositoryGuid: repositoryGuid || '',
            docGuid: copyAfterDocGuid || '',
        };
        const url = buildPath(routers.Knowledge.path, params);
        window.open(url);
    }
    function successToast(copyAfterDocGuid?: string) {
        if (!hasToastSuccess.current) {
            toast({
                content: <>
                    <span>{intl.formatMessage({id: 'successCopyDoc'})}</span>
                    <a type="plain" onClick={() => jumpToNewRep(copyAfterDocGuid)} className={styles.successJump}>去查看</a>
                </>,
                type: ToastType.Success,
            });
            hasToastSuccess.current = true;
        }
    }

    function successToastSidebar() {
        if (!hasToastSuccess.current) {
            toast({
                content: intl.formatMessage({id: 'successCopyDoc'}), type: ToastType.Success,
            });
            hasToastSuccess.current = true;
        }
    }

    function errorToast(err?: any) {
        let errContent = '';
        if (err?.code === 'WizErrorNetwork') {
            errContent = err?.message.includes('timeout') ? 'errorCopyTimeout' : 'errorCopyDoc';
        } else if (err?.code === CopyErrorType.NoPermission || err?.code === CopyErrorType.NotRepoMember) {
            errContent = 'errorCopyNoPermission';
        } else if (err?.code === CopyErrorType.Copying) {
            errContent = 'errorCopying';
        } else if (err?.code === CopyErrorType.OverMaxCount) {
            errContent = 'errorCopyOverMaxCount';
        } else if (err?.code === CopyErrorType.BookToBook) {
            errContent = 'errorCopyOverBookToBook';
            // setOpen(false);
        } else if (err?.code === CopyErrorType.SameDoc) {
            errContent = 'errorCopyOverSamePath';
        } else if (err?.code === CopyErrorType.NoRep) {
            errContent = 'errorCopyAndMOveNoRep';
        } else if (err?.code === CopyErrorType.NoRepCode) {
            errContent = 'errorCopyAndMOveNoRep';
        } else if (err?.code === CopyErrorType.NoPath) {
            errContent = 'errorCopyAndMOveNoPath';
        } else if (err?.code === CopyErrorType.NoDoc) {
            errContent = 'errorCopyAndMOveNoDoc';
        } else if (err?.code === CopyErrorType.SameDocCode) {
            errContent = 'errorCopyOverSamePath';
        } else if (err?.code === CopyErrorType.SamePath) {
            errContent = 'errorCopyAndMOveSamePath';
        } else if (err?.code === CopyErrorType.NoParent) {
            errContent = 'errorCopyAndMOveNoParent';
        } else if (err?.code === CopyErrorType.NoDepartment) {
            errContent = 'errorCopyAndMOveNoDepartment';
        } else if (err?.code === CopyErrorType.NoCurDocPermission) {
            errContent = 'errorCopyAndMOveNoCurDocPermission';
        } else if (err?.code === CopyErrorType.NoChildDocPermission) {
            errContent = 'errorCopyNoChildDocPermission';
        } else if (err?.code === CopyErrorType.NoSelectCurDir) {
            errContent = 'errorCopyNoSelectCurDir';
        } else if (err?.code === CopyErrorType.ExternalTypeError) {
            errContent = 'errorCopyExternalTypeError';
        } else if (err?.code === CopyErrorType.ExternalPublicError) {
            errContent = 'errorCopyExternalPublicError';
        } else {
            errContent = 'errorCopyDoc';
        }
        toast({
            content: intl.formatMessage({id: errContent}), duration: 3000, type: ToastType.Error,
        });
    }


    async function getRepositoryInfo(params: {
        spaceGuid: string;
         groupGuid:string;
         repositoryGuid:string;
    }) {
        try {
            const res = await sdk.as.getRepositoryByGuidNoFixName(params.spaceGuid, params.groupGuid, params.repositoryGuid);
            return res;
        } catch (error) {
            console.log(error);
        }
    }

    async function handleSelectRepository(newRepository: string) {
        try {
            const repositoryInfo = JSON.parse(newRepository);
            // 点击目录树节点的鉴权
            const permissionParms = {
                toRepoGuid: repositoryInfo.repositoryGuid,
                docGuid: isBatch ? '' : docGuid,
                type: 1,
            };
            setCurParent(null);
            const ksServer = await sdk.getKsServer();
            const repoInfo = await getRepositoryInfo({...repositoryInfo});
            const permissionResult = await ksServer.copyAndMovePermissionVerification(permissionParms);
            if (!permissionResult) {
                getToastText('检测到你的权限已经发生变化，请刷新后重试', ToastType.Error);
                setIsDisabled(true);
                return;
            }
            if (permissionResult) {
                setIsDisabled(false);
                setNewRepository({...repositoryInfo, ...repoInfo});
                setRepNoExist(false);
                setNoDepartment(false);
            }
        } catch (err: any) {
            setIsDisabled(true);
            if (err?.code === CopyErrorType.NoRep || err?.code === CopyErrorType.NoRepCode) {
                setRepNoExist(true);
            } else if (err?.code === CopyErrorType.NoDepartment) {
                setNoDepartment(true);
            } else if (err?.code === CopyErrorType.NotRepoMember || err?.code === CopyErrorType.NoPower) {
                getToastText('检测到你的权限已经发生变化，请刷新后重试', ToastType.Error);
            }
        }
    }

    // 重置状态
    function handleCancel() {
        setOpen(false);
        setNewRepository(null);
        setIsDisabled(true);
        setSearchVal('');
        setInputValue('');
        setMoveIsChecked(true);
        setbtnLoading(false);
        // setRepoListStatus(listStatus.loading);
        setCurParent(null);
        setisDocChlid(false);
        setisPageOne(true);
    }

    // 获取可复制知识库列表
    async function getListRepository(value: string, isFirst?: boolean, page = 1) {
        if (page !== 1) {
            setisPageOne(false);
        }
        setShowInput(true);
        setHasMore(true);
        setrollLoading(true);
        const data = {
            docGuid: isBatch ? '' : docGuid,
            page: page,
            pageSize: 30,
            q: value,
        };
        try {
            const ksServer = await sdk.getKsServer();
            const reposResult = await ksServer.searchRepositoriesList(data);
            const recentPathList = await ksServer.getRecentPath();
            setRecentPathList(recentPathList);
            if (Object.keys(reposResult).length === 2 && reposResult.otherRepos.length === 0) {
                setnoRepData(true);
                return;
            }
            setnoRepData(false);
            setError(false);
            setrollLoading(false);
            setHasMore(page < reposResult.total / 30);
            if (Object.keys(reposResult).length) {
                setSearchVal(value);
                let list: any[] = [];
                if (page === 1) {
                    list = [...reposResult?.otherRepos];
                    if (reposResult.personRepo) {
                        list.unshift(reposResult.personRepo);
                    }
                    if (reposResult.currentRepo) {
                        list.unshift(reposResult.currentRepo);
                    }
                    const res = await getRepositoryInfo({...list[0]});
                    setNewRepository({...list[0], ...res});
                } else {
                    list = [...repository, ...reposResult?.otherRepos];
                }
                setRepository(list);
            } else {
                isFirst && setShowInput(false);
                setRepository([]);
            }
        } catch (error) {
            console.log(error);
            setnoRepData(false);
            setError(true);
            setHasMore(false);
            if (page === 1) {
                setRepository([]);
            }
        } finally {
            setrollLoading(false);
        }
    }

    function checkIsPublicOrDocType() {
        let noDocOrBook = false;
        if (isBatch) {
            batchCopyList.forEach(item => {
                if (item.type !== DOC_TYPE.DIRECTORY && item.type !== DOC_TYPE.DOCUMENT) {
                    noDocOrBook = true;
                }
            });
        } else {
            noDocOrBook = curDocument?.type !== DOC_TYPE.DIRECTORY && curDocument?.type !== DOC_TYPE.DOCUMENT;
        }
        return {
            noDocOrBook,
        };
    }

    async function copy() {
        let timeout: any = null;
        if (!newRepository || !repository) {
            return;
        }
        try {
            assert(copyDocument);
            const {docGuid, title, type} = copyDocument;
            const repository = store.getCurRepository();
            assert(repository);
            const {
                repositoryGuid,
                operationType,
                roleName = '',
            } = newRepository;
            const {noDocOrBook} = checkIsPublicOrDocType();
            const isExternalRepo = newRepository?.external;
            if (isExternalRepo && noDocOrBook) {
                setInvalidType(InvalidType.noDocOrBook);
                setInvalidVisible(true);
                return;
            }
            const ksServer = await sdk.getKsServer(repository);
            const isPathSelect = true;
            const params = {
                docGuid: docGuid,
                name: intl.formatMessage({id: 'defaultCopyDocumentSuffix'}, {title}),
                withChild: isDocChlid ? moveIsChecked : false,
                version: store.getRwMode() ? 'latest' : '',
                toParentGuid: curParent?.docGuid || '',
                toRepoGuid: repositoryGuid,
                isPathSelect: isPathSelect,
                choosePath: true,
            };
            let hasResponse = false;
            if (moveIsChecked) {
                // 500ms没有复制完毕，就展示进度弹窗，轮询展示复制的进度
                timeout = setTimeout(() => {
                    if (!hasResponse) {
                        setLoading(false);
                        setOpen(false);
                        setShowProgress(true);
                    }
                }, 500);
            }
            setLoading(true);
            const res = await ksServer.newCopyDoc(docGuid, type, params, moveIsChecked ? 120000 : 15000); // 带子级超时2分钟
            hasResponse = true;
            setLoading(false);
            setShowProgress(false); // 请求返回，隐藏进度浮窗
            if (res && res.successCount && !res.failCount) {
                setOpen(false);
                successToast(res.docs[0].docGuid);
            } else {
                errorToast();
            }
            feLogger(docCopyToRep({
                operation_type: operationType || 0,
            }));
            if (!getIsMoveRepo(roleName)) {
                feLogger(clickPageMoveRep({
                    moveType: 1,
                }));
            }
            handleCancel();
        } catch (err) {
            console.error(err);
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            setLoading(false);
            setShowProgress(false);
            errorToast(err);
        }
    }

    async function batchCopy() {
        let timeout: any = null;
        if (!newRepository || !repository) {
            return;
        }
        try {
            assert(copyDocument);
            const repository = store.getCurRepository();
            assert(repository);
            const {
                repositoryGuid,
            } = newRepository;
            const {noDocOrBook} = checkIsPublicOrDocType();
            const isExternalRepo = newRepository?.external;
            if (isExternalRepo && noDocOrBook) {
                setInvalidType(InvalidType.noDocOrBook);
                setInvalidVisible(true);
                return;
            }
            const ksServer = await sdk.getKsServer(repository);
            const params = {
                repositoryGuid: repository.repositoryGuid,
                docGuids: batchCopyList.map(item => item.docGuid),
                toRepoGuid: repositoryGuid,
                toParentGuid: curParent?.docGuid || '',
                action: 'copy',
            };
            let hasResponse = false;
            // 500ms没有复制完毕，就展示进度弹窗，轮询展示复制的进度
            timeout = setTimeout(() => {
                if (!hasResponse) {
                    setLoading(false);
                    setOpen(false);
                    setShowProgress(true);
                }
            }, 500);
            setLoading(true);
            const res = await ksServer.batchCopyMoveTo(params, 120000);
            if (!res) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                setLoading(false);
                setShowProgress(false);
                getToastText('检测到你的权限已经发生变化，请刷新后重试', ToastType.Error);
                return;
            }
            hasResponse = true;
            setLoading(false);
            setShowProgress(false); // 请求返回，隐藏进度浮窗
            if (res && res.successCount && !res.failCount) {
                hasToastSuccess.current = false;
                successToast(res.docs[0].docGuid);
            } else {
                toast({
                    content: '复制失败，详情将通过"知识通知”服务号告知',
                    type: ToastType.Error,
                    duration: -1,
                    manualClose: true,
                });
            }
            store.setSidebarSelectBatch(false);
            store.setTreeSelectedObj({
                checkedKeys: [],
                halfCheckedKeys: [],
                filterCheckedKeys: [],
                selectedCount: 0,
            });
            feLogger(clickBatchCopy({
                successCount: res?.successCount || 0,
                failCount: res?.failCount || 0,
            }));
            handleCancel();
            if (repository.repositoryGuid === repositoryGuid) {
                store.setIsShowSidebar(false);
                setTimeout(() => {
                    store.setIsShowSidebar(true);
                }, 0);
            }
        } catch (err: any) {
            console.error(err);
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            setLoading(false);
            setShowProgress(false);
            let text = '';
            if (err?.code === 301 || err?.code === 403) {
                getToastText('检测到你的权限已经发生变化，请刷新后重试', ToastType.Error);
                return;
            } else if (navigator.onLine) {
                errorToast(err);
                return;
            } else {
                text = '网络异常，请稍后重试';
            }
            toast({
                content: text,
                type: ToastType.Error,
                duration: 2000,
            });
        }
    }

    async function copyBase() {
        let timeout: any = null;
        try {
            assert(copyDocument);
            const {docGuid, title, type} = copyDocument;
            const repository = store.getCurRepository();
            assert(repository);
            const ksServer = await sdk.getKsServer(repository);
            const isPathSelect = false;
            const params = {
                docGuid: docGuid,
                name: intl.formatMessage({id: 'defaultCopyDocumentSuffix'}, {title}),
                withChild: isWithChild,
                version: store.getRwMode() ? 'latest' : '',
                toParentGuid: '',
                toRepoGuid: repository.repositoryGuid,
                isPathSelect: isPathSelect,
            };
            let hasResponse = false;
            if (isWithChild) {
                // 500ms没有复制完毕，就展示进度弹窗，轮询展示复制的进度
                timeout = setTimeout(() => {
                    if (!hasResponse) {
                        setLoading(false);
                        setShowConfirm(false);
                        setShowProgress(true);
                    }
                }, 500);
            }
            setLoading(true);
            const res = await ksServer.copyDoc(docGuid, type, params, isWithChild ? 120000 : 15000); // 带子级超时2分钟
            hasResponse = true;
            setLoading(false);
            setShowProgress(false); // 请求返回，隐藏进度浮窗
            if (res && res.successCount && !res.failCount) {
                setShowConfirm(false);
                successToastSidebar();
            } else {
                errorToast();
            }
        } catch (err) {
            console.error(err);
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            setLoading(false);
            setShowProgress(false);
            errorToast(err);
        }
    }

    useEffect(() => {
        if (copyDocument) {
            setIsSidebar(copyDocument.isSidebar);
        }
        if (copyDocument && copyDocument.docGuid) {
            setIsWithChild(false);
            hasToastSuccess.current = false;
            if (copyDocument.isSidebar) {
                if (copyDocument.hasChild) {
                    setShowConfirm(true);
                } else {
                    copyBase();
                }
            }
        }
        return () => {
            setLoading(false);
            setOpen(false);
            setShowConfirm(false);
            setShowProgress(false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [copyDocument]);

    function handleLoadMore(page: number) {
        getListRepository(inputValue, false, page);
    }
    useEffect(() => {
        open && getListRepository('', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    function handleClearValue() {
        setInputValue('');
        getListRepository('');
    }
    // async function handleConfirm() {
    //     if (curDocument?.type === DOC_TYPE.DIRECTORY &&
    //          curDocument?.childCount && curDocument?.childCount > 0 && !moveIsChecked) {
    //         setAgainOpen(true);
    //         return '';
    //     }
    //     // return moveToRepository();
    // }
    function handleChecked(e: any, checked: boolean) {
        setMoveIsChecked(checked);
    }
    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value;
        setInputValue(value);
        clearTimeout(timer);
        setIsDisabled(true);
        timer = setTimeout(() => {
            getListRepository(value);
        }, 700);
    }
    function handleTreeSelect(node: any) {
        setCurParent(node);
    }
    function handleTreeLoading(isTreeLoading: boolean) {
        setIsDisabled(isTreeLoading);
    }
    function handleNoMoveToast() {
        toast({
            content: intl.formatMessage({id: 'errorCopyOverBookToBook'}), duration: 3000, type: ToastType.Error,
        });
    }

    function searchList() {
        return (<SidebarSearchList
            list={repository}
            recentPathList={recentPathList}
            loadMore={handleLoadMore}
            hasMore={hasMore}
            error={error}
            loading={rollLoading}
            onSelectRepository={handleSelectRepository}
            searchVal={searchVal}
            newRepository={newRepository}
            inputValue={inputValue}
        />);
    }
    function dirDocsList() {
        return (<LazyDocTree
            curRepo={newRepository}
            toSaveDocGuid={docGuid}
            langTexts={langTexts}
            onSelect={handleTreeSelect}
            onTreeLoading={handleTreeLoading}
            errorToast={errorToast}
            setIsDisabled={setIsDisabled}
            moveIsChecked={moveIsChecked}
            type={1}
            onNoMoveToRepoToast={handleNoMoveToast}
            batchList={batchCopyList}
            isBatch={isBatch}
            operateType={'copy'}
        />);
    }

    function handleProgressFinish() {
        setShowProgress(false);
        successToast();
    }

    function handleProgressTimeout() {
        setShowProgress(false);
        toast({
            content: intl.formatMessage({id: 'errorCopyTimeout'}), type: ToastType.Error,
        });
    }

    const suffix = (inputValue && <Icon
        svg={ClearSearchInput}
        size={IconSize.MD}
        onClick={handleClearValue}
        className={styles.clearValue}
    />);

    async function handleRightConfirm() {
        if (isBatch) {
            batchCopy();
        } else {
            copy();
        }
    }
    function handleFocus() {
        setisBorder(false);
    }
    function handleBlur() {
        setisBorder(true);
    }

    return (
        !isSidebar ?
            <>
                <ConfirmDialog
                    className={classNames(styles.root, isBatch && styles.batchCopyRoot)}
                    headline={
                        <Text type={TextType.T14} color={TextColor.Dark} className={styles.headline}>
                            <FormattedMessage id={'titleCopyDocument'} />
                        </Text>
                    }
                    visible={open}
                    confirmDisabled={!newRepository}
                    onCancel={handleCancel}
                    showCloseX
                    showHeader
                >
                    {
                        <DialogBody>
                            {isBatch ? <BatchOperate batchList={batchCopyList} action={'copy'} /> : ''}
                            <div className={styles.dialogBody}>
                                <div className={styles.confirmContent}>
                                    <div className={styles.confirmInput}>
                                        {
                                            showInput && <Input
                                                value={inputValue}
                                                prefix={<Icon
                                                    svg={MoveSearchSvg}
                                                    size={IconSize.XL}
                                                    noSpace
                                                    className={styles.disabledOpacity}
                                                />}
                                                suffix={suffix}
                                                placeholder={intl.formatMessage({id: 'searchRepository'})}
                                                onChange={handleChange}
                                                onFocus={handleFocus}
                                                onBlur={handleBlur}
                                                className={isBorder ?
                                                    classNames(styles.inputSearch, styles.inputSearchBorder)
                                                    : styles.inputSearch}
                                            />
                                        }
                                    </div>
                                    {
                                        !noRepData
                                            ? <div className={styles.repositoriesList}>
                                                {
                                                    searchList()
                                                }
                                            </div>
                                            : null
                                    }
                                </div>
                                {
                                    !noRepData
                                        ? <>
                                            {
                                                !(error && !rollLoading && isPageOne) ?
                                                    <div className={styles.splitLine}></div>
                                                    : null
                                            }
                                            <div className={styles.confirmContentRighht}>
                                                {
                                                    (repNoExist || noDepartment) ?
                                                        (
                                                            repNoExist ?
                                                                <div className={styles.repositoriesNoExistentBox}>
                                                                    <div>当前知识库不存在或已被删除</div>
                                                                </div> :
                                                                <div className={styles.repositoriesNoExistentBox}>
                                                                    <div>该知识库存在异常，暂时无法操作</div>
                                                                </div>
                                                        ) :
                                                        // eslint-disable-next-line react/jsx-indent
                                                        <div className={styles.dirDocsList}>
                                                            {
                                                                // useState的异步性导致一开始数据为空，需等待数据拿到在渲染
                                                                // eslint-disable-next-line no-negated-condition
                                                                newRepository !== null
                                                                    ? dirDocsList()
                                                                    : null
                                                            }
                                                        </div>
                                                }
                                            </div>
                                        </>
                                        : null
                                }
                            </div>
                            {
                                noRepData
                                    ? <MoveCopySearchNoData className={styles.noDataStatus} text={langTexts.noData} />
                                    : null
                            }
                            {
                                error && !rollLoading && isPageOne
                                    ? <StatusError
                                        className={styles.noDataStatus}
                                        text={'加载失败'}
                                        retryText={'重新加载'}
                                        onRetry={() => getListRepository('')}
                                    />
                                    : null
                            }
                        </DialogBody>
                    }
                    <DialogFoot className={styles.dialogFoot}>
                        {
                            isDocChlid && !isBatch
                        && <Checkbox defaultChecked={moveIsChecked} onChange={handleChecked} className={styles.checkBox}>
                            将子页面同步复制
                        </Checkbox>
                        }
                        <div className={styles.BtnShow}>
                            <Button
                                size={ButtonSize.MD}
                                shape={'circle'}
                                // type={'important'}
                                className={styles.btnBox}
                                onClick={handleCancel}
                            >取消</Button>
                            <Button
                                size={ButtonSize.MD}
                                shape={'circle'}
                                type={'important'}
                                loading={btnLoading}
                                className={
                                    classNames(styles.btnBox,
                                        isDisabled && styles.disabledOpacity,
                                        btnLoading && styles.btnLoading)
                                }
                                onClick={handleRightConfirm}
                                disabled={isDisabled}
                            >{btnLoading ? '' : '复制到该路径下'}</Button>
                        </div>
                    </DialogFoot>
                </ConfirmDialog>
                <Modal
                    visible={loading}
                    className={styles.loading}
                    destroyOnHide
                >
                    <Loading visible={loading} message={'正在复制'} />
                </Modal>
                {
                    showProgress &&
                        <CopyProgress
                            onFinish={handleProgressFinish}
                            onTimeout={handleProgressTimeout}
                            onError={() => setShowProgress(false)}
                        />
                }
                <ExternalWarnDialog
                    invalidVisible={invalidVisible}
                    onClose={() => {
                        setInvalidVisible(false);
                    }}
                    invalidType={invalidType}
                    dialogType={'copy'}
                />
            </> : <>
                <ConfirmDialog
                    visible={showConfirm}
                    showCloseX={false}
                    showHeader={false}
                    onConfirm={() => copyBase()}
                    onCancel={() => setShowConfirm(false)}
                >
                    <div style={{fontWeight: 600, marginBottom: 4}}>确定复制该页面么？</div>
                    <div>
                        <Checkbox
                            checked={isWithChild}
                            onChange={(e, checked) => setIsWithChild(checked)}
                        >同时复制该页面下所有子页面</Checkbox>
                    </div>
                </ConfirmDialog>
                <Modal
                    visible={loading}
                    className={styles.loading}
                    destroyOnHide
                >
                    <Loading visible={loading} message={'正在复制'} />
                </Modal>
                {
                    showProgress &&
                        <CopyProgress
                            onFinish={handleProgressFinish}
                            onTimeout={handleProgressTimeout}
                            onError={() => setShowProgress(false)}
                        />
                }
            </>
    );
}

const CopyDocumentImpl = store.connect([
    store.KEYS.COPY_DOCUMENT,
])(CopyDocument);

export default CopyDocumentImpl;
